import { render, staticRenderFns } from "./CmsAdsCategory.vue?vue&type=template&id=67b708b7&scoped=true&"
import script from "./CmsAdsCategory.vue?vue&type=script&lang=js&"
export * from "./CmsAdsCategory.vue?vue&type=script&lang=js&"
import style0 from "./CmsAdsCategory.vue?vue&type=style&index=0&id=67b708b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b708b7",
  null
  
)

export default component.exports